import {getSessionSubscription} from "@sfs/utils/registrationsUtilities";

export const getEndpointInSession = (endpoint, session, registrations) => {
  return endpoint === "categories"
    ? session.activity?.category // There is not always an activity, especially in preview mode in orga-front. So we use "?"
    : endpoint === "activities"
    ? session.activity
    : endpoint === "teams"
    ? session.team
    : endpoint === "sessions"
    ? session
    : endpoint === "places"
    ? session.places
    : endpoint === "stewards"
    ? session.stewards
    : endpoint === "registrations"
    ? registrations?.filter((r) => getSessionSubscription(r, session))
    : []; // Not supposed to happen at all but just in case
};
